import { Base } from './base.resource';

export interface JsonOfferType {
  id: number;
  name?: string;
}

export class OfferType extends Base {
  public id: number;
  public name: string;

  constructor(jsonOfferType: JsonOfferType) {
    super();

    jsonOfferType = this.convertToUnderscore(jsonOfferType);

    this.id = jsonOfferType.id;
    this.name = jsonOfferType.name;
  }
}
